import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';
import { cn } from '@/hooks/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  href?: string;
  size?: 'sm' | 'md' | 'lg';
  target?: string;
  rel?: string;
}
export const Button = t0 => {
  const $ = _c(22);
  let children;
  let className;
  let href;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      variant: t1,
      size: t2,
      href,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = href;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    className = $[2];
    href = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const variant = t1 === undefined ? "primary" : t1;
  const size = t2 === undefined ? "md" : t2;
  let t3;
  if ($[7] !== className || $[8] !== size || $[9] !== variant) {
    const variants = {
      primary: "bg-[#7c38f6] text-white hover:bg-[#6b2ee0]  border border-transparent",
      secondary: "bg-blue-100 text-blue-700 hover:bg-blue-200",
      outline: "border border-[#E0E0E0] text-white hover:bg-white/10",
      ghost: "hover:bg-slate-100 text-slate-600"
    };
    const sizes = {
      sm: "h-8 px-4 text-xs",
      md: "h-[40px] px-6 py-2 text-sm leading-5",
      lg: "h-12 px-8 text-lg"
    };
    t3 = cn("cursor-pointer inline-flex items-center justify-center rounded-full font-medium transition-all duration-200 focus:outline-none  disabled:opacity-50 disabled:pointer-events-none  font-sans", variants[variant], sizes[size], className);
    $[7] = className;
    $[8] = size;
    $[9] = variant;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const classes = t3;
  if (href) {
    const t4 = props.onClick as any;
    let t5;
    if ($[11] !== children || $[12] !== classes || $[13] !== href || $[14] !== props.rel || $[15] !== props.target || $[16] !== t4) {
      t5 = <Link href={href} className={classes} onClick={t4} target={props.target} rel={props.rel}>{children}</Link>;
      $[11] = children;
      $[12] = classes;
      $[13] = href;
      $[14] = props.rel;
      $[15] = props.target;
      $[16] = t4;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    return t5;
  }
  let t4;
  if ($[18] !== children || $[19] !== classes || $[20] !== props) {
    t4 = <button className={classes} {...props}>{children}</button>;
    $[18] = children;
    $[19] = classes;
    $[20] = props;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
};